import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { Events } from './VisualBackground'

export default class VisualBackgroundGhost extends Component {
    prepare() {
        EventBus.on(Events.Change, this.handleChange)
    }

    destroy() {
        EventBus.off(Events.Change, this.handleChange)
    }

    handleChange = ({ height }) => {
        this.element.style.height = `${height}px`
    }
}
